export default __webpack_public_path__ + "static/media/icon_connections.dc72a7a0.svg";